export default __webpack_public_path__ + "static/media/select-lang-bg.63d8ba78.png";